import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';

const EventDatePicker = (props) => {
  const { eventDate, setEventDate } = props;
  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    if (!eventDate) {
      setEventDate(moment().utc().toISOString());
    }
  }, []);

  const onChange = (date) => {
    if (!date) return setEventDate(null);
    setEventDate(date.utc().toISOString());
  };

  if (isMobile) {
    const localValue = eventDate
      ? moment.utc(eventDate).local().format('YYYY-MM-DDTHH:mm')
      : '';

    const displayText = eventDate
      ? moment.utc(eventDate).local().format('MMM D, YYYY h:mm A')
      : 'Tap to set date & time';

    const onNativeChange = (e) => {
      if (!e.target.value) return setEventDate(null);
      setEventDate(moment(e.target.value).utc().toISOString());
    };

    return (
      <div className="deployment-date-picker-container">
        <div style={{ position: 'relative' }}>
          {/* Styled display — iOS native input renders invisibly so we own the display */}
          <div
            style={{
              background: '#03304B',
              color: eventDate ? 'white' : 'rgba(255,255,255,0.45)',
              border: '1px solid #8197A5',
              borderRadius: '6px',
              padding: '0.5rem 0.75rem',
              fontSize: '1rem',
              lineHeight: '1.5',
            }}
          >
            {displayText}
          </div>
          {/* Transparent native input layered on top to trigger the system picker */}
          <input
            type="datetime-local"
            value={localValue}
            onChange={onNativeChange}
            style={{
              position: 'absolute',
              inset: 0,
              opacity: 0,
              width: '100%',
              height: '100%',
              cursor: 'pointer',
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="deployment-date-picker-container">
      <DatePicker
        value={eventDate ? moment.utc(eventDate).local() : null}
        onChange={onChange}
        className="deployment-date-picker"
        // keeps dropdown from showing up behind the modal
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        showTime={{ format: 'h:mm a', use12Hours: true }}
        format="YYYY-MM-DD h:mm a"
      />
    </div>
  );
};

EventDatePicker.propTypes = {
  eventDate: PropTypes.string,
  setEventDate: PropTypes.func,
};

EventDatePicker.defaultProps = {
  eventDate: '',
  setEventDate: () => {},
};

export default EventDatePicker;
